import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PersonalizeActions, PersonalizeFacade } from './+state';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [PersonalizeActions, PersonalizeFacade],
})
export class PersonalizeModule {}
